var assign = require('./assign')

/**
 * 该方法已废弃，被 assign 替换
 * @param target 目标对象
 * @param sources 多个对象
*/
var extend = assign

module.exports = extend



//////////////////
// WEBPACK FOOTER
// ./~/_xe-utils@2.8.3@xe-utils/methods/object/extend.js
// module id = 1932
// module chunks = 106